import Drawer from "material-ui/Drawer";
export default Drawer;



// WEBPACK FOOTER //
// ./src/components/uielements/drawers/index.js